import React from 'react';
import styled from 'styled-components';
import Label from './Label';
import Error from './Error';
import useInput from '../../../hooks/useInput';

const Input = ({ label, type, name, value, onChange, onBlur, error }: any) => {
  const { focused, handleBlur, handleChange, handleFocus, hasValue } = useInput({
    onChange,
    name,
    value,
  });

  const handleBlurInput = (event) => {
    handleBlur(event);
    if (onBlur) onBlur(name, value);
  };

  return (
    <Wrapper>
      <Label active={hasValue || focused}>{label}</Label>
      <StyledInput
        type={type}
        name={name}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlurInput}
        value={value}
      />
      {error && <Error>{error}</Error>}
    </Wrapper>
  );
};

export default Input;

const Wrapper = styled.label`
  display: block;
  position: relative;
`;

const StyledInput = styled.input<any>`
  width: 100%;
  height: 40px;
  padding: 8px;
  background: #fff;
  border: 1px solid #e1e1e1;
  border-radius: 4px;
  font-size: 16px;
  box-sizing: border-box;
  outline: none;
  box-shadow: none;

  &:hover {
    box-shadow: 0 0 1px rgba(0, 0, 0, 0.5);
  }

  &:focus {
    box-shadow: 0 0 1px rgba(0, 0, 0, 0.8);
  }
`;
